import { Action, createReducer, on } from '@ngrx/store';
import { ApiLegalDocuments } from '@app/core/legal-documents/api-legal-documents';
import { loadLegalDocumentsSuccess } from '@app/core/store/legal-documents/actions';

export type LegalDocumentsState = ApiLegalDocuments;
export const initialState: LegalDocumentsState = {
  terms: null,
  privacyPolicy: null,
  cookiePolicy: null,
};

export const reducers = createReducer(initialState,
  on(loadLegalDocumentsSuccess,
    (state: LegalDocumentsState, { legalDocuments }): LegalDocumentsState => ({
      ...state,
      ...legalDocuments,
    }),
  ),
);

export function legalDocumentsReducer(state: LegalDocumentsState, action: Action): LegalDocumentsState {
  return reducers(state, action);
}
